import React from "react";
import EmailVerification from "@components/EmailVerification";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const EmailVerifyPage = () => {

    return (
        <VersionedLayout minimal>
            <EmailVerification />
        </VersionedLayout>
    );
};

export default EmailVerifyPage;
